import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

import NavbarComponent from "@/components/NavbarComponent.vue";
import {onMounted, onUnmounted, ref} from "vue";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "./components/FooterImpressum.vue";
import "@/assets/styles/main.css"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isMobile = ref(window.innerWidth <= 768);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isMobile.value)
      ? (_openBlock(), _createBlock(NavbarComponent, { key: 0 }))
      : (_openBlock(), _createBlock(SidebarComponent, { key: 1 })),
    _createVNode(_component_router_view),
    _createVNode(FooterImpressum)
  ]))
}
}

})